<template>
  <section style="padding:0 5%;">
    <el-form ref="form" label-position="top" status-icon :model="form" :rules="rules" label-width="100px"
             style="width:100%;overflow:auto">
      <el-divider content-position="left">版本信息</el-divider>
      <el-form-item label="版本" prop="version" required>
        <el-input placeholder="请输入版本" v-model="form.version">
        </el-input>
      </el-form-item>

      <el-form-item label="链接" prop="src" required>
        <el-input placeholder="请输入链接" v-model="form.src">
        </el-input>
      </el-form-item>

      <el-form-item label="类型" prop="type" required>
        <el-select v-model="form.type" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button @click="close('form')">取消</el-button>
        <el-button type="primary" @click="addAssistant('form')" :plain='true'>立即添加</el-button>
      </el-form-item>

    </el-form>
  </section>
</template>

<script>
  let _this;
  import {addData,getSelect} from '@/api/version.js';

  export default {
    data() {
      return {
        form: {
          version: '',
          type: '',
          src: '',
        },
        value: '',
        options: [{
          value: 0,
          label: '整包'
        }, {
          value: 1,
          label: 'wgt包'
        }],

        rules: {
          version: [
            {required: true, message: "请输入版本", trigger: "blur"},
          ],
          src: [
            {required: true, message: "请输入链接", trigger: "blur"},
          ],
          type: [
            {required: true, message: "请选择类型", trigger: "change"},
          ],
        },
      };
    },
    computed: {},

    mounted() {
      _this = this;
      _this.init();
    },

    methods: {
      init(){
      },
      // 数据初始化
      close() {
        _this.$emit('close');
      },

      agentChange(e){
        if(e && !this.form.idcard){
          this.$message.error("请先完成认证")
          this.form.is_agent = 0;
        }
      },

      //  添加
      addAssistant(form) {

        _this.$refs["form"].validate(valid => {
          if (valid) {
            addData(_this.form)
              .then((res) => {
                if (res.code === 200) {
                  _this.$message({
                    message: "添加成功",
                    type: "success",
                  });
                  setTimeout(() => {
                    _this.$emit("success");
                  }, 1000);
                }
              })
              .catch(error => {
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      handleDistrictsChoose(e) {
        _this.form.province_id = e.province.code
        _this.form.city_id = e.city.code
        _this.form.area_id = e.area.code
      },
    }
  };
</script>
<style lang="scss" scoped>
  .el-drawer {
    overflow: auto !important;
  }

  .avatar-uploader .el-upload {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    border: 1px dashed #ccc;
    border-radius: 50%;
    overflow: hidden;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
